<template>
  <v-container fluid>
    <!-- Information about schools the applicant attended -->
    <h3 class='primary--text text-xs-left mt-4 mb-4'>Degree Information</h3>
    <v-layout row wrap v-for="education in Education" :key="education.Id" class='extra-pad'>
      <degree-info :disableFields="disableFields" :education="education" class="mt-2 mb-4"></degree-info>
    </v-layout>
  </v-container>
</template>
<script>
import DegreeInfoVue from './Education/DegreeInfo.vue';
export default {
  name: 'Education',
  props: {
    Education: Array, 
    disableFields: Boolean
  },
  data() {
    return {
      items: ['Undergraduate', 'Graduate']
    }
  },
  methods: {},

  components: {
    'degree-info' : DegreeInfoVue
  },
  watch: {
    Education: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
}
</script>